module.exports = __webpack_public_path__ + "ad301347e94b0df21180e668322ee4ed.png";